import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../util/datetime'
import CustomerLink from '../../../customer/component/CustomerLink'
import { renderStateName } from '../../../process/util/names'
import Select from '../../../form/component/Select'


const SalesOrderStatus = ({ salesOrder, salesOrderStatusList, salesOrderTreatmentStatusList, changeSalesOrder, saveSalesOrder }) => {
    if (salesOrder.hasProcess) {
        return (<span>{renderStateName(salesOrder.status)}</span>)
    }
    const valueList = (salesOrder.type === 'set') ? salesOrderStatusList : salesOrderTreatmentStatusList
    return (<Select
        object={salesOrder}
        name="status"
        valueList={valueList}
        onChange={(name, value) => {
            changeSalesOrder(name, value)
            saveSalesOrder()
        }}
    />)
}


const SalesOrderInfoTable = (props) => {
    const { salesOrder } = props
    const hasProcess = salesOrder.hasProcess
    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Customer</td>
                    <td><CustomerLink customer={salesOrder.customer}/></td>
                </tr>
                {hasProcess && (
                    <tr>
                        <td>Process</td>
                        <td><Link to={'/process/instance/view-by-master-id/salesorder_salesorder/' + salesOrder.id}>view</Link></td>
                    </tr>)
                }

                <tr>
                    <td>Status</td>
                    <td><SalesOrderStatus {...props}/></td>
                </tr>
                <tr>
                    <td>Created</td>
                    <td>{formatDateTime(salesOrder.created)}</td>
                </tr>
                <tr>
                    <td>Reference Number</td>
                    <td>{salesOrder.referenceNumber}</td>
                </tr>
            </tbody>
        </table>
    )
}

SalesOrderInfoTable.propTypes = {
    salesOrder: PropTypes.object.isRequired,
}

export default SalesOrderInfoTable




// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderInfoTable.js